export default "__VITE_ASSET__knbZ9AoS__"